import React, { useEffect, useState, useContext } from "react";
import { Form, Input, Select, Modal, message, Typography, Spin, Button } from "antd";
import { platformApi } from "../../../../api";
import { ContextAPI } from "../../../../ContextAPI";

const { Text } = Typography;
const { Option } = Select;

const PaymentModal = ({ open, close, form, bookingId, module, refreshData }) => {
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields, validateFields } = form;
  const [loading, setLoading] = useState(false);
  const [bankOptions, setBankOptions] = useState([]);
  const [data, setData] = useState({});
  const { loginCredintials } = useContext(ContextAPI)

  // Denomination State
  const defaultDenoms = [
    { denomination: 500, count: 0 },
    { denomination: 200, count: 0 },
    { denomination: 100, count: 0 },
    { denomination: 50, count: 0 },
    { denomination: 20, count: 0 },
    { denomination: 10, count: 0 },
    { denomination: 5, count: 0 },
    { denomination: 2, count: 0 },
    { denomination: 1, count: 0 },
  ];
  const [showDenominationModal, setShowDenominationModal] = useState(false);
  const [collectedDenominations, setCollectedDenominations] = useState([]); // Cash Given by us
  const [changeDenominations, setChangeDenominations] = useState([]); // Change Received from receiver
  const [step, setStep] = useState(1);
  const [hasChangeToReturn, setHasChangeToReturn] = useState(true);
  const [pendingSubmitValues, setPendingSubmitValues] = useState(null); // Store form values while modal is open
  const [denominationInventory, setDenominationInventory] = useState([]);

  useEffect(() => {
    if (open) {
      setCollectedDenominations(JSON.parse(JSON.stringify(defaultDenoms)));
      setChangeDenominations(JSON.parse(JSON.stringify(defaultDenoms)));
      setStep(1);
      setHasChangeToReturn(true);
      setPendingSubmitValues(null);
    }
  }, [open]);

  useEffect(() => {
    if (!bookingId) return;
    platformApi
      .get(`/api/booking/${bookingId}`)
      .then((res) => {
        const booking = res.data.response?.data || {};
        const payments = booking.companyPayments || [];
        const cancelpayments = booking.CancellationPayments || [];
        const pays = booking.payments || [];
        const insurancePaid = payments
          .filter((p) => p.paymentType === "INSURANCE")
          .reduce((sum, p) => sum + parseFloat(p.collectedAmount || 0), 0);
        const registrationPaid = payments
          .filter((p) => p.paymentType === "REGISTRATION")
          .reduce((sum, p) => sum + parseFloat(p.collectedAmount || 0), 0);
        const totalCollected = pays
          .filter(p => p.status === "SUCCESS")
          .reduce((sum, p) => sum + parseFloat(p.collectedAmount || 0), 0);
        const affidavitPaid = payments
          .filter((p) => p.paymentType === "AFFIDAVIT")
          .reduce((sum, p) => sum + parseFloat(p.collectedAmount || 0), 0);
        const specialChargesPaid = payments
          .filter((p) => p.paymentType === "specialNoCharges")
          .reduce((sum, p) => sum + parseFloat(p.collectedAmount || 0), 0);
        const cancellationAmountPaid = cancelpayments
          .filter((p) => p.paymentType === "CANCELLATION_REFUND")
          .reduce((sum, p) => sum + parseFloat(p.collectedAmount || 0), 0);
        booking.totalInsurancePaid = insurancePaid;
        booking.totalRegistrationPaid = registrationPaid;
        booking.totalAffidavitPaid = affidavitPaid;
        booking.totalSpecialChargePaid = specialChargesPaid;
        booking.totalCollected = totalCollected;
        booking.totalCancellationAmount = cancellationAmountPaid;
        setData(booking);

        const branchId = booking.branch?.id || booking.branch;
        if (branchId) {
          platformApi.post("/api/payment/denominationInventory", { branch: [typeof branchId === 'object' ? branchId.id : branchId] })
            .then(invRes => {
              if (invRes.data.code === 200 && invRes.data.response.code === 200) {
                setDenominationInventory(invRes.data.response.data[0]?.denominations || []);
              }
            })
            .catch(err => console.error("Error fetching denomination inventory:", err));
        }
      })
      .catch((err) => {
        message.error(err.message || "Failed to fetch booking");
      });
  }, [bookingId]);

  const handleSearchBank = async (value = "") => {
    try {
      const body = { size: 10, searchString: value, page: 1 };
      const { data } = await platformApi.post("/api/company/branches/get", body);
      if (data?.response?.data?.branch) {
        const banks = data.response.data.branch.flatMap((b) =>
          (b.bankDetails || []).map((bank) => ({
            label: `${bank.name} - ${bank.accountNumber}`,
            value: bank.id,
            key: bank.id,
            balance: bank.accountBalance || 0,
          }))
        );

        setBankOptions(banks);
      } else {
        setBankOptions([]);
      }
    } catch (err) {
      console.error(err);
      message.error("Failed to fetch banks");
    }
  };

  const handlePaymentModeChange = (value) => {
    setFieldsValue({ bankId: undefined });
    if (value === "Bank Transfer") handleSearchBank("");
  };

  const handlePaymentModuleChange = (value) => {
    if (!data || !data.price) return;
    let totalAmount = 0;
    let alreadyPaid = 0;

    let prefillAmount = 0;
    if (value === "INSURANCE") {
      totalAmount = parseFloat(data.price.insuranceAmount || 0);
      alreadyPaid = parseFloat(data.totalInsurancePaid || 0);
    } else if (value === "REGISTRATION") {
      const reg = parseFloat(data.price?.registrationFee || 0);
      const tax = parseFloat(data.price?.roadTax || 0);
      const handling = parseFloat(data.price?.handlingCharges || data.vehicle?.price?.[0]?.handlingCharges || 0);
      const tempReg = parseFloat(data.price?.tempRegister || 0);
      const numPlate = parseFloat(data.price?.numberPlate || 0);
      totalAmount = reg + tax + handling + tempReg + numPlate;

      alreadyPaid = parseFloat(data.totalRegistrationPaid || 0);
    } else if (value === "AFFIDAVIT") {
      totalAmount = parseFloat(data.price.affidavit || 0);
      alreadyPaid = parseFloat(data?.totalAffidavitPaid || 0);
    } else if (value === "specialNoCharges") {
      totalAmount = parseFloat(data?.price?.specialNoCharges || 0);
      alreadyPaid = parseFloat(data?.totalSpecialChargePaid || 0);
    } else if (value === "specialNoCharges") {
      totalAmount = parseFloat(data?.price?.specialNoCharges || 0);
      alreadyPaid = parseFloat(data?.totalSpecialChargePaid || 0);
    } else if (value === "CANCELLATION_REFUND") {
      totalAmount = parseFloat((data?.totalCollected - data?.cancellationAmount) || 0);
      alreadyPaid = parseFloat(data?.totalCancellationAmount || 0);
    }

    // if (value === "INSURANCE") {
    //   prefillAmount = parseFloat(data.price.insuranceAmount || 0);
    // } else if (value === "REGISTRATION") {
    //   const reg = parseFloat(data.price.registrationFee || 0);
    //   const tax = parseFloat(data.price.roadTax || 0);
    //   const handling = parseFloat(data.vehicle?.price?.[0]?.handlingCharges || 0);
    //   prefillAmount = reg + tax + handling;
    // }

    // setFieldsValue({ amount: prefillAmount || undefined });
    const pendingAmount = totalAmount - alreadyPaid;

    setFieldsValue({ amount: pendingAmount > 0 ? pendingAmount : 0 });
  };

  const totalCollected = collectedDenominations.reduce(
    (sum, d) => sum + d.denomination * (parseInt(d.count) || 0),
    0
  );

  const totalChange = changeDenominations.reduce(
    (sum, d) => sum + d.denomination * (parseInt(d.count) || 0),
    0
  );

  const paymentAmount = pendingSubmitValues ? parseFloat(pendingSubmitValues.amount || 0) : 0;
  const autoChange = Math.max(totalCollected - paymentAmount, 0);

  const handleDenominationSubmit = () => {
    if (hasChangeToReturn === true) {
      if (totalChange !== autoChange) {
        message.warning(
          "Change denominations do not match auto-calculated change"
        );
        return;
      }
    } else {
      // If no change received/returned, clear change denominations
      setChangeDenominations(JSON.parse(JSON.stringify(defaultDenoms)));
    }

    // Proceed with submission using pending values and denominations
    submitPayment(pendingSubmitValues);
    setShowDenominationModal(false);
  }


  const handleSubmit = async () => {
    validateFields(async (err, values) => {
      if (err) return;

      const { paymentMode } = values;

      if (paymentMode === "CASH") {
        setPendingSubmitValues(values);
        setShowDenominationModal(true);
      } else {
        submitPayment(values);
      }
    });
  };

  const submitPayment = async (values) => {
    const { paymentModule, paymentMode, bankId, amount } = values;
    const enteredAmount = parseFloat(amount || 0);


    let maxAmount = 0;
    if (paymentModule === "INSURANCE") {
      maxAmount = parseFloat(data.price?.insuranceAmount || 0);
    } else if (paymentModule === "REGISTRATION") {
      const reg = parseFloat(data.price?.registrationFee || 0);
      const tax = parseFloat(data.price?.roadTax || 0);
      const handling = parseFloat(data.price?.handlingCharges || data.vehicle?.price?.[0]?.handlingCharges || 0);
      const tempReg = parseFloat(data.price?.tempRegister || 0);
      const numPlate = parseFloat(data.price?.numberPlate || 0);
      maxAmount = reg + tax + handling + tempReg + numPlate;
    } else if (paymentModule === "AFFIDAVIT") {
      maxAmount = parseFloat(data.price.affidavit || 0);
    } else if (paymentModule === "specialNoCharges") {
      maxAmount = parseFloat(data?.price?.specialNoCharges || 0);
    } else if (paymentModule === "CANCELLATION_REFUND") {
      maxAmount = parseFloat(((data?.totalCollected - data?.cancellationAmount) - data?.totalCancellationAmount) || 0);
    }

    // CHANGE: Add negative amount validation
    if (parseFloat(amount) < 0) {
      message.error("Amount cannot be negative");
      return;
    }

    if (parseFloat(amount) > maxAmount && paymentModule != "FUEL" && paymentModule != "CANCELLATION_PAYMENT") {
      message.error(`Amount cannot exceed ₹${maxAmount}`);
      return;
    }

    if (paymentMode === "Bank Transfer" && (paymentModule === "CANCELLATION_REFUND" || paymentModule === "CANCELLATION_PAYMENT")) {
      const selectedBank = bankOptions.find(b => b.value === bankId);
      if (selectedBank && (selectedBank.balance !== undefined && parseFloat(amount) > selectedBank.balance)) {
        message.error(`Amount cannot exceed the available bank balance (₹${selectedBank.balance})`);
        return;
      }
    }

    const payload = {
      paymentType: paymentModule,
      paymentMode,
      bankDetails: bankId || null,
      collectedAmount: parseFloat(amount || 0),
      status: "SUCCESS",
      module: "BOOKING",
      moduleId: bookingId,
      paidBy: loginCredintials.id,
      billAmount: maxAmount || 0,
      denominations:
        paymentMode === "CASH"
          ? [
            ...collectedDenominations
              .filter((d) => d.count > 0)
              .map((d) => ({ ...d, type: "CREDIT" })), // Cash Given (Money going out/in depending on perspective, user said "Cash Payment" module)
            // Wait, for Company Payment (Money Out):
            // collectedDenominations = Cash Given by Company to Receiver? 
            // changeDenominations = Change Received back from Receiver?
            // The backend logic provided says: 
            // collectedAmount = newlycollected - changeReturned;
            // newlycollected (CREDIT) adds to total
            // changeReturned (DEBIT) subtracts
            // So user gives CASH (CREDIT) and receives Change (DEBIT) to get net paid amount.
            // Yes.
            ...changeDenominations
              .filter((d) => d.count > 0)
              .map((d) => ({ ...d, type: "DEBIT" })),
          ]
          : [],
    };

    try {
      setLoading(true);
      const { data: resp } = await platformApi.post("/api/payment/company-payment/", payload);
      if (resp.code === 200) {
        message.success("Payment successfully created!");

        if (paymentModule === "CANCELLATION_REFUND" && enteredAmount == maxAmount) {
          try {
            const statusResp = await platformApi.put(
              `/api/booking/updateStatus/${bookingId}`,
              {
                bookingStatus: "REJECTED_REFUNDED",
              }
            );

            if (statusResp.data.code !== 200) {
              message.error("Failed to update booking status");
            }
          } catch (error) {
            console.error(error);
            message.error("Error processing cancellation refund");
          }
        }

        if (refreshData) {
          refreshData();
        }
        resetFields();
        close();
      } else {
        message.error(resp.message || "Failed to create payment");
      }
    } catch (err) {
      console.error(err);
      message.error("Error while submitting payment");
    } finally {
      setLoading(false);
    }
  };

  const paymentMode = getFieldValue("paymentMode");

  const clearFields = () => resetFields();
  const selectedModule = getFieldValue("paymentModule");

  let maxAllowed;

  if (selectedModule === "INSURANCE") {
    maxAllowed =
      (data?.price?.insuranceAmount || 0) -
      (data?.totalInsurancePaid || 0);
  } else if (selectedModule === "REGISTRATION") {
    const total =
      (data?.price?.registrationFee || 0) +
      (data?.price?.roadTax || 0) +
      (data?.price?.handlingCharges || data?.vehicle?.price?.[0]?.handlingCharges || 0) +
      (data?.price?.tempRegister || 0) +
      (data?.price?.numberPlate || 0);

    maxAllowed = total - (data?.totalRegistrationPaid || 0);
  } else if (selectedModule === "AFFIDAVIT") {
    maxAllowed =
      (data?.price?.affidavit || 0) -
      (data?.totalAffidavitPaid || 0);
  } else if (selectedModule === "specialNoCharges") {
    maxAllowed =
      (data?.price?.specialNoCharges || 0) -
      (data?.totalSpecialChargePaid || 0);
  } else if (selectedModule === "CANCELLATION_REFUND") {
    maxAllowed =
      ((data?.totalCollected - data?.cancellationAmount) || 0) -
      (data?.totalCancellationAmount || 0);
  }


  return (
    <>
      <Modal
        title="Payment"
        visible={open}
        onCancel={() => {
          close();
          clearFields();
        }}
        onOk={handleSubmit}
        okText="Submit"
        confirmLoading={loading}
        okButtonProps={{
          disabled:
            !getFieldValue("paymentModule") ||
            !getFieldValue("paymentMode") ||
            !getFieldValue("amount") ||
            parseFloat(getFieldValue("amount")) <= 0 ||
            (getFieldValue("paymentMode") === "Bank Transfer" && !getFieldValue("bankId")) ||
            (maxAllowed <= 0 && selectedModule !== "FUEL")
        }}
      >
        <Spin spinning={loading}>
          <Form layout="vertical">


            {module === "CANCELLATION_PAYMENT" ? (
              /** ---- Show Only Cancellation Refund ---- */
              <Form.Item label="Payment Module">
                {getFieldDecorator("paymentModule", {
                  rules: [{ required: true, message: "Please select module" }],
                })(
                  <Select placeholder="Select Module" onChange={handlePaymentModuleChange}>
                    <Option value="CANCELLATION_REFUND">Cancellation Refund</Option>
                  </Select>
                )}
              </Form.Item>
            ) : (
              /** ---- Normal Modules ---- */
              <Form.Item label="Payment Module">
                {getFieldDecorator("paymentModule", {
                  rules: [{ required: true, message: "Please select module" }],
                })(
                  <Select placeholder="Select Module" onChange={handlePaymentModuleChange}>
                    <Option value="INSURANCE">Insurance</Option>
                    <Option value="REGISTRATION">Registration</Option>
                    {data?.price?.affidavit > 0 && (
                      <Option value="AFFIDAVIT">Affidavit</Option>
                    )}
                    {data?.price?.specialNoCharges > 0 && (
                      <Option value="specialNoCharges">specialNoCharges</Option>
                    )}
                    <Option value="FUEL">Fuel expenses</Option>
                  </Select>
                )}
              </Form.Item>
            )}

            <Form.Item label="Payment Mode">
              {getFieldDecorator("paymentMode", {
                rules: [{ required: true, message: "Please select payment mode" }],
              })(
                <Select placeholder="Select Payment Mode" onChange={handlePaymentModeChange}>
                  <Option value="CASH">Cash</Option>
                  <Option value="Bank Transfer">Bank Transfer</Option>
                </Select>
              )}
            </Form.Item>

            {paymentMode === "Bank Transfer" && (
              <Form.Item label="Select Bank">
                {getFieldDecorator("bankId", {
                  rules: [{ required: true, message: "Please select a bank" }],
                })(
                  <Select
                    showSearch
                    placeholder="Search Bank"
                    onSearch={handleSearchBank}
                    filterOption={false}
                  >
                    {bankOptions.map((b) => (
                      <Option key={b.key} value={b.value}>
                        {b.label}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            )}

            <Form.Item label="Amount">
              {getFieldDecorator("amount", {
                rules: [
                  { required: true, message: "Enter amount" },
                  // CHANGE: Add custom validator for negative numbers
                  {
                    validator: (_, value) => {
                      if (value && parseFloat(value) < 0) {
                        return Promise.reject("Amount cannot be negative");
                      }
                      return Promise.resolve();
                    },
                  },
                ],
              })(
                <Input
                  type="number"
                  placeholder="Enter amount"
                  min="0" // CHANGE: Add min attribute to HTML5 number input
                  onKeyDown={(e) => {
                    // CHANGE: Prevent typing of minus sign
                    if (e.key === '-' || e.key === 'e') {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => e.target.blur()} // CHANGE: Prevent scroll wheel from changing value
                />
              )}
              {getFieldValue("paymentModule") && (
                <Text type="secondary" style={{ fontSize: 12 }}>
                  Max allowed: ₹
                  {(() => {
                    const module = getFieldValue("paymentModule");

                    if (module === "INSURANCE") {
                      const total = data?.price?.insuranceAmount || 0;
                      const paid = data?.totalInsurancePaid || 0;
                      return total - paid;
                    } else if (module === "REGISTRATION") {
                      const total =
                        (data?.price?.registrationFee || 0) +
                        (data?.price?.roadTax || 0) +
                        (data?.price?.handlingCharges || data?.vehicle?.price?.[0]?.handlingCharges || 0) +
                        (data?.price?.tempRegister || 0) +
                        (data?.price?.numberPlate || 0);

                      const paid = data?.totalRegistrationPaid || 0;

                      return total - paid;
                    } else if (module === "AFFIDAVIT") {
                      const total = data?.price?.affidavit || 0;
                      const paid = data?.totalAffidavitPaid || 0;
                      return total - paid;
                    } else if (module === "specialNoCharges") {
                      const total = data?.price?.specialNoCharges || 0;
                      const paid = data?.totalSpecialChargePaid || 0;
                      return total - paid;
                    } else if (module === "CANCELLATION_REFUND") {
                      const total = (data?.totalCollected - data?.cancellationAmount) || 0;
                      const paid = data?.totalCancellationAmount || 0;
                      return total - paid;
                    }
                    return 0;
                  })()}
                </Text>
              )}
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
      {/* Denomination Modal */}
      <Modal
        visible={showDenominationModal}
        title={step === 1 ? "Enter Cash Provided" : "Enter Change Received"}
        onCancel={() => {
          setStep(1);
          setShowDenominationModal(false);
        }}
        footer={[
          step === 2 && (
            <Button key="back" onClick={() => setStep(1)}>
              Back
            </Button>
          ),
          step === 1 && (
            <Button
              key="next"
              type="primary"
              onClick={() => {
                if (totalCollected < paymentAmount) {
                  message.error(
                    "Cash provided cannot be less than bill amount"
                  );
                  return;
                }
                const autoChangeAmount = Math.max(totalCollected - paymentAmount, 0);
                if (autoChangeAmount === 0) {
                  // No change needed, skip step 2
                  setChangeDenominations(JSON.parse(JSON.stringify(defaultDenoms)));
                  setHasChangeToReturn(false);
                  submitPayment(pendingSubmitValues);
                  setShowDenominationModal(false);
                } else {
                  setStep(2);
                }
              }}
            >
              {Math.max(totalCollected - paymentAmount, 0) === 0 ? "Submit" : "Next"}
            </Button>
          ),
          step === 2 && (
            <Button
              key="submit"
              type="primary"
              onClick={handleDenominationSubmit}
              loading={loading}
            >
              Submit
            </Button>
          ),
        ]}
      >
        {step === 1 ? (
          <>
            <h4>
              Amount to be Paid:{" "}
              <span
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  padding: "2px 6px",
                  background: "#f9f9f9",
                  display: "inline-block",
                  minWidth: "40px",
                  textAlign: "center",
                }}
              >
                {paymentAmount}
              </span>
            </h4>

            <h4>Cash Provided</h4>
            {collectedDenominations.map((d, index) => (
              <div
                key={d.denomination}
                style={{
                  marginBottom: 8,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span style={{ width: 80 }}>{d.denomination} :</span>
                <Input
                  type="number"
                  min="0"
                  value={d.count === 0 ? "" : d.count}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val === "" || /^[0-9]+$/.test(val)) {
                      const parsedVal = val === "" ? "" : parseInt(val);
                      if (parsedVal !== "" && (module === "CANCELLATION_PAYMENT" || selectedModule === "CANCELLATION_REFUND")) {
                        const inv = denominationInventory.find(inv => inv.denomination === d.denomination);
                        const maxCount = inv ? inv.count : 0;
                        if (parsedVal > maxCount) {
                          message.warning(`Maximum available ₹${d.denomination} notes is ${maxCount}`);
                          return;
                        }
                      }
                      const newDenoms = [...collectedDenominations];
                      newDenoms[index].count = parsedVal;
                      setCollectedDenominations(newDenoms);
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={(e) => {
                    if (["-", "e", "+", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  style={{ width: 80, marginRight: 16 }}
                />

                <span>Total: {d.denomination * (d.count || 0)}</span>
              </div>
            ))}

            <div style={{ marginTop: 16 }}>
              <strong>Total Provided: </strong> {totalCollected}
            </div>

            <div style={{ marginTop: 16 }}>
              <strong>Change to be Received: </strong>{" "}
              {Math.max(totalCollected - paymentAmount, 0)}
            </div>
          </>
        ) : (
          <>
            <h4>Change Received</h4>

            {hasChangeToReturn && (
              <>
                {changeDenominations.map((d, index) => (
                  <div
                    key={d.denomination}
                    style={{
                      marginBottom: 8,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ width: 80 }}>{d.denomination} :</span>
                    <Input
                      type="number"
                      min="0"
                      value={d.count === 0 ? "" : d.count}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val === "" || /^[0-9]+$/.test(val)) {
                          const newDenoms = [...changeDenominations];
                          newDenoms[index].count =
                            val === "" ? "" : parseInt(val);
                          setChangeDenominations(newDenoms);
                        }
                      }}
                      style={{ width: 80, marginRight: 16 }}
                    />
                    <span>Total: {d.denomination * (d.count || 0)}</span>
                  </div>
                ))}
              </>
            )}
            {/*
            <div style={{ marginBottom: 16 }}>
              <strong>Receive Change?</strong>
              <Radio.Group
                value={hasChangeToReturn}
                onChange={(e) => setHasChangeToReturn(e.target.value)}
                style={{ marginLeft: 16 }}
              >
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </div>
            */}

            <div style={{ marginTop: 16 }}>
              <strong>Total Change Received: </strong> {totalChange}
            </div>
            {hasChangeToReturn ? (
              <div style={{ marginTop: 16 }}>
                <strong>Expected Change: </strong> {autoChange}
              </div>
            ) : (
              <div>No change</div>
            )}
          </>
        )}
      </Modal>
    </>
  );
};

export default Form.create()(PaymentModal);
